import MISWritebackStatusFilters from "root/s360components/WondeWebhookAdmin/MISWritebackStatusFilters";
import {useState} from "react";
import MisStatusToolManager from "root/s360components/WondeWebhookAdmin/MisStatusToolManager";
import {ALL_MIS_STATUS, ANY_DATE} from "root/DataFunctions/MisStatusManagerDataFns";

const MisStatusToolContainer = ({}) =>
{

    const [statusFilter, setStatusFilter] = useState(ALL_MIS_STATUS);

    const [dateFilter, setDateFilter] = useState(ANY_DATE);


    const showFilters = false; //Change in the future if we want to add specific filters to this


    const onStatusSelectChange = ( data ) =>
    {
        setStatusFilter(data);
    }

    const onDateChange = ( data ) =>
    {
        setDateFilter(data);
    }


    return (
        <div>
            <h2>Registration Writeback Status Management Tool</h2>
            <p key='this-screen'>This screen allows admins to view and manage MIS status for all registration records</p>
            <p key='All-users' style={{color: '#b77171'}}>Last 14 days of webhook responses</p>
            <label>Use the search bar to filter for all attributes in the table.</label>
            {showFilters && <MISWritebackStatusFilters onStatusSelectChange={onStatusSelectChange} onDateChange={onDateChange} key='MWSF'/>}
            <MisStatusToolManager statusFilter={statusFilter} dateFilter={dateFilter}/>
        </div>
    )
}

export default MisStatusToolContainer;